import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderDashboard from '../header/headerDashboard';

const PROCEDURES = [
    {
        id: 'desinfection',
        icon: '🧼',
        title: 'Procédure de désinfection',
        subtitle: 'Entre chaque patient — obligatoire',
        tag: 'ARS / PSDM',
        tagColor: '#1a7f4b',
        sections: [
            {
                title: 'Équipements de protection',
                steps: [
                    'Enfiler les gants à usage unique avant toute manipulation.',
                    'Porter une blouse si nécessaire (contexte isolement).',
                ],
            },
            {
                title: 'Nettoyage préalable',
                steps: [
                    'Retirer les draps, alèses et protections. Mettre en sac hermétique.',
                    'Passer un chiffon humide (eau + détergent) sur l\'ensemble de la structure pour éliminer les souillures visibles.',
                ],
            },
            {
                title: 'Désinfection',
                steps: [
                    'Appliquer le désinfectant agréé sur les zones à traiter : barrières, télécommande, potence, structure du cadre, vérins et pieds de lit.',
                    'Respecter le temps de contact indiqué sur la fiche produit (généralement 5 à 10 min).',
                    'Laisser sécher à l\'air libre — ne pas essuyer.',
                ],
            },
            {
                title: 'Enregistrement',
                steps: [
                    'Aller sur la fiche du lit dans l\'application.',
                    'Cliquer sur "Marquer comme nettoyé" pour enregistrer le nettoyage dans l\'historique.',
                    'Le lit passe automatiquement en statut "Disponible".',
                ],
            },
        ],
    },
    {
        id: 'maintenance',
        icon: '🔧',
        title: 'Procédure de maintenance',
        subtitle: 'Préventive (annuelle) & corrective (sur panne)',
        tag: 'LPPR',
        tagColor: '#2980b9',
        sections: [
            {
                title: 'Contrôle annuel (maintenance préventive)',
                steps: [
                    'Vérifier le bon fonctionnement de chaque moteur (montée/descente dossier, relevé de jambe, hauteur).',
                    'Tester la télécommande filaire et/ou sans fil, vérifier les boutons et l\'affichage.',
                    'Contrôler les barrières : ouverture, verrouillage, usure des clips.',
                    'Inspecter la visserie et les fixations (aucun jeu anormal).',
                    'Vérifier la stabilité globale du lit : aucun balancement, roulettes freinées.',
                    'Contrôler l\'état des câbles électriques (pas d\'effilochage, de pincement ou de coupure).',
                    'Effectuer un cycle complet de toutes les positions motorisées.',
                    'Enregistrer la maintenance préventive dans l\'historique du lit (type : Préventive, description du contrôle effectué).',
                ],
            },
            {
                title: 'Sur panne (maintenance corrective)',
                steps: [
                    'Mettre le lit immédiatement à l\'écart — apposer une étiquette "Hors service".',
                    'Ne pas louer ce lit jusqu\'à réparation complète.',
                    'Identifier la panne (moteur, carte électronique, câble, mécanique).',
                    'Procéder à la réparation ou au remplacement de la pièce défaillante.',
                    'Effectuer un test complet après intervention.',
                    'Remettre en service uniquement si tous les tests sont satisfaisants.',
                    'Enregistrer la maintenance corrective dans l\'historique du lit (type : Corrective, description de la panne et de la réparation).',
                ],
            },
        ],
    },
    {
        id: 'livraison',
        icon: '🚚',
        title: 'Procédure de livraison / installation',
        subtitle: 'À chaque départ en location',
        tag: 'PSDM',
        tagColor: '#7d3c98',
        sections: [
            {
                title: 'Vérification avant départ',
                steps: [
                    'Contrôler que le lit est en statut "Disponible" (désinfection validée, aucune maintenance en cours).',
                    'Vérifier l\'intégrité visuelle : aucune pièce manquante, aucun dommage apparent.',
                    'S\'assurer que les accessoires requis sont présents (barrières, télécommande, potence si prescrite).',
                    'Charger le lit et les accessoires dans le véhicule.',
                ],
            },
            {
                title: 'Installation au domicile',
                steps: [
                    'Positionner le lit dans la pièce définie avec le patient/famille (espace suffisant, prise électrique à proximité).',
                    'Assembler les barrières et accessoires.',
                    'Brancher le lit et tester toutes les fonctions motorisées.',
                    'Vérifier la stabilité et le frein des roulettes.',
                    'Contrôler la sécurité : aucun câble au sol pouvant provoquer une chute.',
                ],
            },
            {
                title: 'Remise au patient',
                steps: [
                    'Expliquer au patient et/ou à l\'aidant le fonctionnement de la télécommande.',
                    'Indiquer les consignes de sécurité (barrières, positions, charge max).',
                    'Remettre la notice d\'utilisation si disponible.',
                    'Valider la livraison dans l\'application (début de location : numéro de lit, client, pharmacie).',
                ],
            },
        ],
    },
    {
        id: 'reprise',
        icon: '📦',
        title: 'Procédure de reprise du matériel',
        subtitle: 'À chaque fin de location',
        tag: 'PSDM',
        tagColor: '#7d3c98',
        sections: [
            {
                title: 'Reprise au domicile',
                steps: [
                    'Vérifier l\'état général du lit avant démontage (noter tout dommage constaté).',
                    'Démonter les barrières, accessoires et télécommande.',
                    'Trier les accessoires : ceux réutilisables (après désinfection) et ceux à jeter.',
                    'Charger le lit et les accessoires dans le véhicule de manière sécurisée.',
                ],
            },
            {
                title: 'Retour au dépôt',
                steps: [
                    'Décharger et faire passer le lit en zone "Désinfection" — ne pas le mélanger avec les lits disponibles.',
                    'Déclarer la fin de location dans l\'application (le lit passe automatiquement en statut "Sale").',
                    'Si casse ou dommage constaté : bloquer le lit en statut "Hors service" et créer une maintenance corrective.',
                    'Procéder à la désinfection complète selon la procédure dédiée avant toute nouvelle location.',
                ],
            },
        ],
    },
    {
        id: 'tracabilite',
        icon: '📋',
        title: 'Procédure de traçabilité',
        subtitle: 'Obligation réglementaire — ARS / LPPR',
        tag: 'ARS / LPPR',
        tagColor: '#c0392b',
        sections: [
            {
                title: 'Informations obligatoires à renseigner pour chaque lit',
                steps: [
                    'Numéro de série du lit (identifiant unique du matériel).',
                    'Date de livraison au patient.',
                    'Date de reprise du matériel.',
                    'Date et validation de la désinfection (enregistrée dans l\'historique nettoyage).',
                    'Date et détail de la maintenance préventive (enregistrée dans l\'historique maintenance).',
                    'Date, nature et détail de toute maintenance corrective (pannes, réparations).',
                    'Remarques éventuelles : état anormal, accessoires manquants, refus patient, incident.',
                ],
            },
            {
                title: 'Rappels réglementaires',
                steps: [
                    'Toute intervention sur le matériel (nettoyage, maintenance) doit être tracée dans l\'application.',
                    'En cas de contrôle ARS, l\'historique complet doit être consultable par lit et par période.',
                    'Les données de traçabilité doivent être conservées a minima 5 ans.',
                    'En cas d\'incident matériel avec le patient, un rapport doit être établi et conservé.',
                ],
            },
        ],
    },
];

const ProcedureCard = ({ procedure }) => {
    const [open, setOpen] = useState(false);
    const [openSections, setOpenSections] = useState([0]);

    const toggleSection = (i) => {
        setOpenSections(prev =>
            prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]
        );
    };

    return (
        <div style={{
            border: '1px solid #e0e0e0',
            borderRadius: 10,
            marginBottom: 12,
            overflow: 'hidden',
            boxShadow: open ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
        }}>
            {/* En-tête accordéon */}
            <button
                onClick={() => setOpen(!open)}
                style={{
                    width: '100%',
                    background: open ? '#f7f9fc' : '#fff',
                    border: 'none',
                    padding: '14px 18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    textAlign: 'left',
                    borderBottom: open ? '1px solid #e0e0e0' : 'none',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
                    <span style={{ fontSize: 22 }}>{procedure.icon}</span>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <span style={{ fontWeight: 'bold', fontSize: 15 }}>{procedure.title}</span>
                            <span style={{
                                fontSize: 10,
                                fontWeight: 'bold',
                                padding: '2px 7px',
                                borderRadius: 10,
                                backgroundColor: procedure.tagColor + '18',
                                color: procedure.tagColor,
                                border: `1px solid ${procedure.tagColor}`,
                                letterSpacing: '0.5px',
                            }}>
                                {procedure.tag}
                            </span>
                        </div>
                        <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{procedure.subtitle}</div>
                    </div>
                </div>
                <span style={{
                    fontSize: 18,
                    color: '#aaa',
                    flexShrink: 0,
                    marginLeft: 8,
                    transform: open ? 'rotate(180deg)' : 'none',
                    transition: 'transform 0.2s',
                }}>
                    ▼
                </span>
            </button>

            {/* Contenu */}
            {open && (
                <div style={{ padding: '16px 18px', backgroundColor: '#fafbfc' }}>
                    {procedure.sections.map((section, i) => (
                        <div key={i} style={{ marginBottom: 8 }}>
                            {/* Sous-section titre */}
                            <button
                                onClick={() => toggleSection(i)}
                                style={{
                                    width: '100%',
                                    background: 'none',
                                    border: 'none',
                                    padding: '8px 0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    borderBottom: '1px solid #eee',
                                    marginBottom: openSections.includes(i) ? 8 : 0,
                                }}
                            >
                                <span style={{ fontWeight: '600', fontSize: 13, color: '#333' }}>
                                    {section.title}
                                </span>
                                <span style={{ fontSize: 12, color: '#bbb' }}>
                                    {openSections.includes(i) ? '▲' : '▼'}
                                </span>
                            </button>

                            {/* Steps */}
                            {openSections.includes(i) && (
                                <ol style={{ paddingLeft: 20, margin: 0 }}>
                                    {section.steps.map((step, j) => (
                                        <li key={j} style={{
                                            fontSize: 13,
                                            color: '#444',
                                            padding: '5px 0',
                                            borderBottom: j < section.steps.length - 1 ? '1px dashed #eee' : 'none',
                                            lineHeight: 1.5,
                                        }}>
                                            {step}
                                        </li>
                                    ))}
                                </ol>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const Procedures = () => {
    const [allOpen, setAllOpen] = useState(false);

    return (
        <div style={{ width: '100%' }}>
            <HeaderDashboard />
            <Container style={{ maxWidth: 760, marginTop: 28, paddingBottom: 40 }}>

                {/* En-tête page */}
                <div style={{ marginBottom: 24 }}>
                    <h1 style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 4 }}>
                        Procédures opérationnelles
                    </h1>
                    <p style={{ color: '#888', fontSize: 13, margin: 0 }}>
                        Procédures obligatoires pour la location de lits médicalisés — conformité ARS / PSDM / LPPR.
                        Ce contenu est fixe et ne peut être modifié que par un administrateur technique.
                    </p>
                </div>

                {/* Sommaire */}
                <div style={{
                    backgroundColor: '#f0f4ff',
                    border: '1px solid #d0daf5',
                    borderRadius: 8,
                    padding: '14px 18px',
                    marginBottom: 20,
                }}>
                    <div style={{ fontWeight: 'bold', fontSize: 12, color: '#555', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Sommaire
                    </div>
                    <ol style={{ margin: 0, paddingLeft: 18 }}>
                        {PROCEDURES.map(p => (
                            <li key={p.id} style={{ fontSize: 13, color: '#444', padding: '2px 0' }}>
                                {p.icon} {p.title}
                            </li>
                        ))}
                    </ol>
                </div>

                {/* Accordéons */}
                {PROCEDURES.map(procedure => (
                    <ProcedureCard key={procedure.id} procedure={procedure} />
                ))}
            </Container>
        </div>
    );
};

export default Procedures;
